import Api from './ApiRequest';

export const sendBulkEmail = (subject, message, recipients) => Api.post(`/cent/email/bulk`, {subject, message, recipients});
